const PUBLIC_ROUTES = ["/auth/callback", "/logout"] as const

export const isPublicRoute = (pathname: string): boolean => PUBLIC_ROUTES.some((route) => pathname.startsWith(route))
